import {useEffect,useRef} from 'react'
import {connect} from 'react-redux'
import { useLocation } from "react-router-dom";

//components
import Loading from '../../assets/controls/loading'
import RequestItem from './request-list-item'
import Pagination from '../../assets/controls/pagination-alt'
import BannerMessage from '../../assets/elements/custom-alert'

//constant
import {DEFAULT_VALUES} from '../../../constant/pagination'
import {GET_REQUEST_STATUS} from '../../../constant/dictionary'

//actions
import { setRequestsDefault, setRequestsSkip } from '../../../actions/my-requests'
import { REQUEST_LIST_TABS } from '../../../constant/my-requests'

//utils
import { getAllRequests, getSelectedRequestByType, loadRequestByHash } from '../../../utils/my-requests'
const RequestList = ({ type, requests, loading, allRequest, skip, setRequestsSkip, onChangeTab }) => {
  const refTopList = useRef(null)
//   const [skip, setSkip] = useState(0)
  const location = useLocation();

  useEffect(() => {
    getAllRequests()
  }, [])
  
  useEffect(() => {
    setRequestsSkip(0)
    // setRequestsDefault()
  }, [type])

  useEffect(() => {
      getSelectedRequestByType(skip, type);
  }, [type,allRequest,skip])

    useEffect(() => {

        if (!location.hash) return;

        const hash = location.hash.slice(1);

        async function findElement(delay = 100) {
            loadRequestByHash(hash, onChangeTab);

            await new Promise(r => setTimeout(r, delay));
        }

        findElement().then(e => {
            const el = document.getElementById(`request_${hash}`);
            if (el) {
                el.scrollIntoView({
                    behavior: "smooth", 
                    block: "center",
                });
            }
        });

    }, [allRequest, onChangeTab, location.hash]);

  return (
    <div ref={refTopList}>
        {requests.data.length > 0 && 
            <div style={{display: 'flex', flexDirection:'column', gap: '10px'}}>
                  {requests.data.map((request, index) =>
                      <RequestItem key={index} request={request}
                          hiddeActions={type !== REQUEST_LIST_TABS.ACTIVE ||
                              (request.statusId !== GET_REQUEST_STATUS.New
                                  && request.statusId !== GET_REQUEST_STATUS.Quoted
                                  && request.statusId !== GET_REQUEST_STATUS.Open
                                  && request.statusId !== GET_REQUEST_STATUS.Reservation_Created
                                  && request.statusId !== GET_REQUEST_STATUS.Booked
                                  && request.statusId !== GET_REQUEST_STATUS.Pending_Extension
                                  && request.statusId !== GET_REQUEST_STATUS.ExtesionRequested
                                  && request.statusId !== GET_REQUEST_STATUS.Pending_Termination
                              )}
                          showSurveyReview={type === REQUEST_LIST_TABS.PAST && request.statusId === GET_REQUEST_STATUS.Booked} />)
                }
            </div>
        }
        {requests.totalCount > 0 && <div style={{display:'flex', gap: '5px',margin: '20px 0'}}>
             <Pagination 
                totalPages={requests.totalCount}
                skip={skip}
                take={DEFAULT_VALUES.take}
                setSkip={setRequestsSkip}
                type='redux'
            />
            <Loading isVisble={loading} size={30}/>
        </div> }
        {requests.totalCount <= 0 && !loading &&
            <BannerMessage>
                You don't have any requests
            </BannerMessage>
        }
    </div>
  )
}

function mapStateToProps({ requests }) {
    return {
        requests: requests.requests,
        allRequest: requests.allRequest,
        loading: requests.loading,
        skip: requests.skip
    };
  }
function mapDispatchToProps(dispatch){
    return{
        setRequestsDefault: () => dispatch(setRequestsDefault()),
        setRequestsSkip: data => dispatch(setRequestsSkip(data))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(RequestList)